import Ajax from "base/Ajax";
import CookieHelper from "base/CookieHelper";
import Message from "base/Message";
import AjaxConfirmModal from "modals/AjaxConfirmModal";
import FindInvoiceModal from "modals/FindInvoiceModal";
import AjaxForm, { EVENT_SUCCESS } from "webPage/AjaxForm";
import Page from "webPage/Page";

Page.register(new RegExp('^/customers/([0-9a-f]+)/projects/([0-9a-f]+)/subscriptions/([0-9a-f]+)/?$'), ([customer_id, project_id, subscription_id]) => {
    let form = new AjaxForm($(".container"), ($form, formData) => {
        return Ajax.post("billing", "subscriptions/" + (subscription_id === "add" ? "" : subscription_id), $.extend({
            customer: customer_id,
            project: project_id,
        }, formData));
    });

    form.on(EVENT_SUCCESS, (data) => {
        if (project_id === "add") {
            CookieHelper.set('did-add-subscription', data.id);
        } else {
            CookieHelper.set('did-update-subscription', data.id);
        }
        window.location.href = data.links.view;
        // Keep loading
        return false;
    });

    $("body").on("click", ".js-cancel-subscription", () => {
        let modal = new AjaxConfirmModal("Are you sure you want to cancel this subscription?", undefined, async () => {
            return Ajax.post("billing", "subscriptions/" + subscription_id + "/cancel");
        });
        modal.on("success", async () => {
            CookieHelper.set('did-cancel-subscription', subscription_id);
            window.location.reload();
        });
        modal.show();

        return false;
    }).on("click", ".js-link-to-invoice", function () {
        let $row = $(this).closest('.js-entry-row');
        let id = $row.attr("data-id");

        let modal = new FindInvoiceModal(subscription_id, id);
        modal.on("linked", ({invoice, line}) => {
            $row.find(".js-invoice-cell").html(
                eotwJSXFactory('a', {href: invoice.links.view}, ["line " + (line.line + 1) + " of " + invoice.invoiceNumber]),
            );
            $row.find(".js-net-value-cell").text(ValueHelper.format_money(line.netValue));
            $row.find(".js-actions-cell").html(buildLinkedActions());
            new Message("The entry has successfully linked to line " + line.line + " of invoice " + invoice.invoiceNumber, "Entry Linked", Message.SUCCESS);
        });
        modal.show();

        return false;
    }).on("click", ".js-unlink-from-invoice", function () {
        let $row = $(this).closest('.js-entry-row');
        let id = $row.attr("data-id");

        let modal = new AjaxConfirmModal("Are you sure you want to unlink this entry?", undefined, async () => {
            return Ajax.delete("billing", "subscriptions/" + subscription_id + "/entries/" + id + "/line", {}, Ajax.ADMIN);
        });

        modal.on("success", () => {
            modal.destroy();
            $row.find(".js-actions-cell").html(buildUnlinkedActions());
            $row.find(".js-invoice-cell,.js-net-value-cell").html(eotwJSXFactory('span', {className: "admin-table__default-value"}, ["N/A"]));

            new Message("The entry has successfully unlinked", "Entry Unlinked", Message.SUCCESS);
        });
        modal.show();
        return false;
    }).on("click", ".js-cancel-entry", function () {
        let $row = $(this).closest('.js-entry-row');
        let id = $row.attr("data-id");

        let modal = new AjaxConfirmModal("Are you sure you want to cancel this entry?", undefined, async () => {
            return Ajax.post("billing", "subscriptions/" + subscription_id + "/entries/" + id + "/cancel", {}, Ajax.ADMIN);
        });

        modal.on("success", () => {
            modal.destroy();
            $row.find(".js-actions-cell").html(buildCancelledActions());
            $row.addClass("admin-table__tr--cancelled");

            new Message("The entry has successfully cancelled", "Entry Cancelled", Message.SUCCESS);
        });

        modal.show();
        return false;
    }).on("click", ".js-restore-entry", function () {
        let $row = $(this).closest('.js-entry-row');
        let id = $row.attr("data-id");

        let modal = new AjaxConfirmModal("Are you sure you want to restore this entry?", undefined, async () => {
            return Ajax.post("billing", "subscriptions/" + subscription_id + "/entries/" + id + "/restore", {}, Ajax.ADMIN);
        });

        modal.on("success", (entry) => {
            modal.destroy();
            $row.find(".js-actions-cell").html(entry.line ? buildLinkedActions() : buildUnlinkedActions());
            $row.removeClass("admin-table__tr--cancelled");

            new Message("The entry has successfully cancelled", "Entry Cancelled", Message.SUCCESS);
            modal.destroy();
        });

        modal.show();
        return false;
    }).on("click", ".js-dismiss-po-warning", function () {
        let modal = new AjaxConfirmModal("Are you sure you want to dismiss the missing Purchase Order?", undefined, async () => {
            await Ajax.post("billing", "subscriptions/" + subscription_id + "/dismiss-po-warning");
        });
        modal.on("success", async () => {
            modal.destroy();

            $(".js-po-warning-wrapper").remove();
        });
        modal.show();
        return false;
    });

});

function buildCancelledActions() {
    return (
        eotwJSXFactory('button', {type: "button", className: "admin-btn admin-btn--flex-grow admin-btn--table admin-btn--primary js-restore-entry"}, ["Restore Entry"])
    );
}

function buildUnlinkedActions() {
    return [
        eotwJSXFactory('button', {type: "button", className: "admin-btn admin-btn--flex-grow admin-btn--table admin-btn--confirm js-link-to-invoice"}, ["Link to Invoice"]),
        eotwJSXFactory('button', {type: "button", className: "admin-btn admin-btn--flex-grow admin-btn--table admin-btn--delete js-cancel-entry"}, ["Cancel Entry"]),
    ];
}

function buildLinkedActions() {
    return (
        eotwJSXFactory('button', {type: "button", className: "admin-btn admin-btn--flex-grow admin-btn--table js-unlink-from-invoice"}, ["Unlink from Invoice"])
    );
}
